import { MessageResponseDto } from "@api/api";
import { zodResolver } from "@hookform/resolvers/zod";
import { cardSeriesFormDefault } from "@factory/form/form.default";
import {
  CardSeriesFormRule,
  CardSeriesFormSchema,
} from "@factory/form/form.rule";
import { useQyActivateCardSeries } from "@factory/query/card-series.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { getFormErrorMessage } from "@shared/utility/get-error-message";

export function useActivateCard() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapActivateCardSeries } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New CardSeries is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: activateCardSeries, isLoading: isCreating } =
    useQyActivateCardSeries(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<CardSeriesFormSchema>({
    defaultValues: cardSeriesFormDefault,
    resolver: zodResolver(CardSeriesFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: CardSeriesFormSchema) => {
    const formData = mapActivateCardSeries(form);
    activateCardSeries(formData);
  };
  const handleValidateError = (err: FieldErrors<CardSeriesFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
